import { TooltipTrigger } from "@visiblethread/react-components";
import { arrayOf, number, shape, string } from "prop-types";
import React from "react";

import styles from "./OpportunityRow.module.scss";
import OpportunityTooltipContent from "./OpportunityTooltipContent";

const OpportunityRow = ({ opportunity, maxDays }) => {
  const { opportunityName, stageName, stageColor, daysInStage } = opportunity;
  const widthPct = Math.max(0, Math.min(100, (daysInStage / maxDays) * 100));

  return (
    <TooltipTrigger
      content={<OpportunityTooltipContent opportunity={opportunity} />}
      maxWidth="400px"
      placement="top"
      delay={1000}
    >
      <li
        className={styles.opportunityRow}
        data-testid="opportunity-row"
      >
        <p className={styles.opportunityRow__name}>{opportunityName}</p>
        <span className={styles.opportunityRow__stage}>
          <span
            aria-hidden="true"
            className={styles.opportunityRow__stageDot}
            data-testid="opportunity-row-stage-dot"
            style={{ backgroundColor: stageColor }}
          />
          {stageName}
        </span>
        <div className={styles.opportunityRow__bar}>
          <span
            className={styles.opportunityRow__barFill}
            data-testid="opportunity-row-bar-fill"
            style={{ width: `${widthPct}%` }}
          />
        </div>
        <span className={styles.opportunityRow__days}>{daysInStage}d</span>
      </li>
    </TooltipTrigger>
  );
};

OpportunityRow.propTypes = {
  opportunity: shape({
    opportunityId: number.isRequired,
    opportunityName: string.isRequired,
    customerName: string.isRequired,
    stageId: number.isRequired,
    stageName: string.isRequired,
    stageColor: string.isRequired,
    daysInStage: number.isRequired,
    assignees: arrayOf(string).isRequired,
  }).isRequired,
  maxDays: number.isRequired,
};

export default OpportunityRow;
